import {
	GetMemberEventLogRequest,
	GetMemberEventLogResponse,
} from '@/modules/manage-member/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getMemberEventLog } from '../../services'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

export default function useQueryGetEventLog(
	payload: GetMemberEventLogRequest,
	props?: UseBaseQueryOptions<GetMemberEventLogResponse>,
) {
	return useQuery({
		queryKey: [OperatorQueryKeys.GetMemberEventLog, payload],
		queryFn: () => getMemberEventLog(payload),
		...props,
	})
}
